module.exports = __webpack_public_path__ + "static/media/JobList.fd153e52.svg";